import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";

const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const changeLanguage = (lang: string) => {
    const currentPath = location.pathname.split("/").slice(2).join("/"); // Récupère la partie après la langue
    i18n.changeLanguage(lang);
    localStorage.setItem("language", lang);

    // Redirige vers la nouvelle langue avec le chemin actuel
    navigate(`/${lang}/${currentPath}`);
  };

  return (
    <div className="language-selector">
      <img
        src="/images/flags/fr.png"
        alt="Français"
        className="flag"
        onClick={() => changeLanguage("fr")}
      />
      <img
        src="/images/flags/en.png"
        alt="English"
        className="flag"
        onClick={() => changeLanguage("en")}
      />
      <img
        src="/images/flags/de.png"
        alt="Deutsch"
        className="flag"
        onClick={() => changeLanguage("de")}
      />
    </div>
  );
};

export default LanguageSelector;
